// Digital road tax is for Individual Malaysians; everyone else (foreigners,
// companies, commercial) gets the physical card delivered.
export const DIGITAL_ROADTAX_HANDLING_FEE = 9;
